export default __webpack_public_path__ + "static/media/frangot-screenshot-02.6cd4b060.png";